<template>
  <div v-if="configobj" class="rhdetail">
    <h2 class="top-title">
    
      <span>故障详情</span>
    </h2>
    <div class="main">
      <div class="title">
        <span class="title1" >{{configobj.failurepro.describe || "-"}}</span>
        <!-- <span class="title2">{{configobj.failurepro.describe || "-"}}</span> -->
      </div>
      <div class="border"></div>
      <div class="description">
        <div class="des">
          <span class="desc">故障位置：</span>
          <span class="descr">{{configobj.topContinousInfo.join(">")}}</span>
        </div>
         <div class="des">
          <span class="desc">故障编码：</span>
          <span class="descr">{{configobj.failurepro.failureCode || "-"}}</span>
        </div>
        <div class="des" >
          <span class="desc">故障类型：</span>
          <span class="descr">{{configobj.failurepro.type  || "-"}}</span>
        </div>
         <div class="des" >
          <span class="desc">严重等级：</span>
          <span class="descr">{{configobj.failurepro.severity || "-"}}</span>
        </div>
      
              <div class="des" >
          <span class="desc">发生概率：</span>
          <span class="descr">{{configobj.failurepro.occurrence_probability || "-"}}</span>
        </div>

        <div class="des" >
          <span class="desc">检查难易：</span>
          <span class="descr">{{configobj.failurepro.difficulty || "-"}}</span>
        </div>
        <div class="des">
          <span class="desc">检查手段：</span>
          <span class="descr">{{configobj.failurepro.detection  || "-"}}</span>
        </div>
        
       <div class="des" v-for="(index,key) in configobj.possibleReasons" :key="key">
          <span class="desc">可能的故障原因{{key+1}}：</span>
          <span class="descr">{{index.describe}}</span>
        </div>
  
          <div class="des">
          <span class="desc">详细描述：</span>
          <span class="descr">
            <span>{{configobj.failurepro.detailDescribe  || "-"}}</span>
            
          </span>
        </div>
        <div class="des">
          <span class="desc">解决方案：</span>
          <span class="descr">
            <span>{{configobj.failurepro.solution  || "-"}}</span>
            
          </span>
        </div>
          <!-- <div class="des" >
          <span class="desc">故障可能原因</span>
          <span class="descr">{{configobj.possibleReasonsString || "-"}}</span>
        </div> -->
          <!-- <div class="des" >
          <span class="desc">关键字</span>
          <span class="descr">{{configobj.keywordString || "-"}}</span>
        </div> -->
           
<!-- 
        <div class="des">
          <span class="desc">故障详情</span>
          <span class="descr">{{configobj.failurepro.detailDescribe || "-"}}</span>
        </div> -->
          <!-- <div class="des">
          <span class="desc">指标体现</span>
          <span class="descr">{{configobj.filString|| "-"}}</span>
        </div> -->
        
      
  
        
        <div class="des">
          <span class="desc">相关案例：</span>
          <span class="descr">{{configobj.failurepro.referenceCase  || "-"}}</span>
        </div>
        <div class="des" >
          <span class="desc">相关图片：</span>
          <span class="descr" v-if="configobj.failurepro.url.length>0">
            <img @click="tomaximg(index)" 
            :onerror="defaultImg" v-for="(index,key) in configobj.failurepro.url" :key="key" :src="index" class="img" />
          </span>
          <span v-else>-</span>
        </div>
      </div>
       <div  class="message" > <span style="color:red">*</span> 诊断意见仅供参考。我们提供的参考诊断意见可能因所用设备类型及其维护、操作条件和环境以及之前使用的润滑剂情况、数据准确性等多种因素而有所差异。客户应根据设备厂家提供的运维手册要求，自主判断和决定针对设备的运维/故障处置方案。</div>
    </div>
    
  </div>
</template>


<script>
  import img from "@/assets/images/empty.png";

 
  import {
    failureInfo
  } from '@/api/business/searchList'
  export default {
    data() {
      return {
        img,
    
        configobj:null,
        defaultImg:img
      };
    },
    created() {

      this.init(this.$route.query.id)

    },
    methods: {
      tomaximg(index){
      this.$pop(index)
      },
      goBack() {
        this.$router.go(-1);
      },
      async init(id) {
        let {
          data
        } = await failureInfo(id)
        this.$store.state.spinShow = false;
     
         data.possibleReasonsString=(data. possibleReasons.map(e=>e.describe)).join(">")
         data.keywordString=data.keyWord.join("，")
       
         data.failureDetailRelatedIndicatorVOS=data.failureDetailRelatedIndicatorVOS.map((item)=>{
       
           let str=item.topName.join("-")
            item.itemfillstring=`${str}-${item.oilApplication}的${item.indicatorName}${item.contentValue}`
            return item
         })
         data.filString=(data.failureDetailRelatedIndicatorVOS.map(e=>e.itemfillstring)).join("，")

        this.configobj=data
      },
    },


  };
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .rhdetail {
    .main {
      min-height: 658px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.050980392156862744);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-top: 16px;
      position: relative;

      .title {
        margin-left: 18px;
        padding-top: 13px;
        font-size: 18px;
    
        font-weight: 600;
        line-height: 20px;

        .title1 {
          color: #555555;
          font-size: 24px;
        }

        .title2 {
          color: #0c479d;
          margin-left: 3px;
        }
      }

      .border {
        height: 0px;
        opacity: 0.2;
        // border-bottom: 1px solid #707070;
        margin-top: 12px;
      }

      .description {
        margin-left: 18px;

        // margin-top:16px;
        .des {
          margin-top: 12px;

          .desc {
            display: inline-block;
            width: 125px;
            // height: 20px;
            margin-right: 15px;
            padding-top: -100px;
            font-size: 14px;

            font-weight: normal;
            color: #aaa;
            line-height: 20px;
            vertical-align: top;
          }

          .descr {
            font-size: 14px;
        
            font-weight: normal;
            color: #515a6e;
            line-height: 20px;

            .img {
              width: 100px;
              height: 100px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }
    .message {
            font-size: 14px;
            font-weight: normal;
            color: #555555;
            line-height: 20px;
            
            position: absolute;
            bottom: 0;
            margin-left: 18px;
            bottom: 18px;
  }
</style>